module.exports = __webpack_public_path__ + "img/bg1.706e8bd.png";